import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Close, DeleteForever, Edit, MoreVert } from '@material-ui/icons';


import { AccountCircle } from '@material-ui/icons';
import axios from 'axios';
import SecurityHeaders from '../../context/SecurityHeaders';
import ENDPOINT from '../../context/EndPoint';
import Snackbar, { SnackbarCloseReason } from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Button, Modal } from "react-bootstrap";
// import BountyUpdate from './BountyUpdate';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';

const BugCard = ({ program,reload }) => {
  const dispatch = useDispatch();
;
  const [open, setOpen] = useState({
    open: false,
    message: '',
  type: ''
  
  });

  const deleteBounty = async (id) => {
    dispatch({type:'LOADING'})
    try {
      const data = new FormData();
      data.append('bounty_id', id);
      const res = await axios.post(ENDPOINT+"delete-bounty.php", data, SecurityHeaders);
      if (res.data.status ==='success') {
        dispatch({type:'DONE_LOADING'})
        reload();
     
        setOpen({open:true,message:res.data.message,type:'success'})
      } else {
        dispatch({type:'ERROR', payload:res.data.message})
        setOpen({open:true,message:res.data.message,type:'error'})
      }
    } catch (error) {
      setOpen({open:true,message:error,type:'error'})
      dispatch({type:'ERROR',payload:error.message})
    }
  };
  const handleClose2 = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(open=>({...open,open:false}));
  };
  return (
    <>

<Snackbar open={open.open} onClose={handleClose2} autoHideDuration={4000} >
        <Alert
          
          severity={open.type === 'success' ? 'success' : 'error'}
          onClose={() => {}}
          variant="filled"
               className='col-md-6 col-12'

        >
          {open.message}
        </Alert>
      </Snackbar>
     
      {/* <Modal show={update} onHide={handleClose}>
        <Modal.Body>
 <BountyUpdate reload={reload} program={program}/>
              </Modal.Body>
      </Modal> */}

   
      <Link to={''} className="col-md-3">
        <div className="card mt-4">
          <div className="card-body shadow-sm d-flex justify-content-between">
            <div>
              <h6 className="text-danger">Bug Bounty</h6>
              <div className="d-flex justify-content-around border-bottom border-1 pb-2 mb-2">
                <img src={program.image} alt="Logo" className="img-fluid mb-2" style={{ height: "60px" }} />
              </div>
              <h5 className="card-title text-primary">{program.bounty_title}</h5>
              <p className="card-text">{program.bounty_description}</p>
              <p className="text mt-2">${program.p1} - ${program.payout}</p>
            </div>
            <div className="ml ms-2">
              <Dropdown className="options-dropdown ml-4">
                <Dropdown.Toggle className="bg-transparent options p-0 w-fit h-fit border-0">
                  <MoreVert className="text-dark" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item >
                    <Link to={'/update-bug-bounty/'+program.bounty_id}><Edit className="m-1 p-1 w-22" /> Edit Course</Link>
                  </Dropdown.Item>
                  <Dropdown.Item onClick={() => deleteBounty(program.bounty_id)}>
                    <DeleteForever className="m-1 p-1 w-22" /> Delete Course
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default BugCard;
